<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="物料编码/物料名称">
              <a-input placeholder="请输入" v-model="queryParam.matcodename"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;cursor: pointer" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" :loading="isDownloadXlsLoading" @click="handleExportXls('泰国ERP报表' + curTime)">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="RowNum"
        :columns="columnsData"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
      </a-table>
    </div>
  </a-card>
</template>

<script>

  import moment from 'moment';
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction } from '@/api/manage'

  export default {
    name: 'ThailandErpReport',
    mixins:[JeecgListMixin],
    props:{
    },
    data () {
      return {
        description: '泰国ERP报表页面',
        disableMixinCreated: true,//禁止直接查询
        createTimeRange:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'数据刷新时间',
            align:"center",
            dataIndex: '数据刷新时间',
            width:120,
          },
          {
            title:'物料主编码',
            align:"center",
            dataIndex: '物料主编码',
            width:120,
          },
          {
            title:'物料编码',
            align:"center",
            dataIndex: '物料编码',
            width:100,
          },
          {
            title:'物料名称',
            align:"center",
            dataIndex: '物料名称',
            width:180,
          },
          {
            title:'现有库存',
            align:"center",
            dataIndex: '现有库存',
            width:100,
          },
          {
            title:'占用汇总',
            align:"center",
            dataIndex: '占用汇总',
            width:100,
          },
          {
            title:'在途数据',
            align:"center",
            dataIndex: '在途数据',
            width:100,
          },
          {
            title:'负库判断',
            align:"center",
            dataIndex: '负库判断',
            width:100,
          }
        ],
        columnsData: [],
        url: {
          list: "/reportForms/base/getMaterialOccupancyDetails",
          exportXlsUrl: "/reportForms/base/report",
          getActivityUrlName: "/feiliuai/busFeiliuaiActivityUrl/getActivityUrlName"
        },
        superFieldList:[],
        isDownloadXlsLoading:false,
        curTime: '',
        ipagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
        },
      }
    },
    created() {
      this.initData();
      this.getSuperFieldList();
      this.curTime = moment(new Date()).format('YYYYMMDDHHmm')
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    watch: {
      createTimeRange: {
        handler(newVal, oldVal) {
          this.queryParam.createTime_begin = newVal[0]?newVal[0].format('YYYY-MM-DD HH:mm:ss'):null;
          this.queryParam.createTime_end = newVal[1]?newVal[1].format('YYYY-MM-DD HH:mm:ss'):null;
        }
      }
    },
    methods: {
      searchReset(){
        this.queryParam = {}
        this.searchQuery();
      },
      initData(){
        this.chooseTypeAll = 'primary'
        this.columnsData = []
        // this.columnsData = this.columnsData.concat(this.columns)
        this.loadData();
      },
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error("请设置url.list属性!")
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        params.field = '';
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = []
            this.dataSource = res.result.records || res.result;
            if (res.result.total || res.result.total === 0) {
              this.ipagination.total = Number(res.result.total);
            }
            setTimeout(() => {
              this.initColumns()
            }, 100)
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      initColumns(){
        console.log('dataSource66666',this.dataSource)
          this.queryParam.matcodename ? this.initColumnsData() : ''
          let textArr = ['数据刷新时间','物料主编码','物料编码','物料名称','现有库存','占用汇总','在途数据','负库判断','RowNum']
          for(let key in this.dataSource[0]) {
            if(textArr.includes(key)){
              continue;
            }else{
              this.columns.push({
                title: key,
                align:"center",
                dataIndex: key
              })
            }
          }
          setTimeout(() => {
            this.columnsData = this.columns.reduce((acc, curr) => acc.find(item => item.title === curr.title) ? acc : [...acc, curr], []);
          }, 100)
      },
      initColumnsData(){
        this.columns = [
          {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:'数据刷新时间',
              align:"center",
              dataIndex: '数据刷新时间',
              width:120,
            },
            {
              title:'物料主编码',
              align:"center",
              dataIndex: '物料主编码',
              width:120,
            },
            {
              title:'物料编码',
              align:"center",
              dataIndex: '物料编码',
              width:100,
            },
            {
              title:'物料名称',
              align:"center",
              dataIndex: '物料名称',
              width:180,
            },
            {
              title:'现有库存',
              align:"center",
              dataIndex: '现有库存',
              width:100,
            },
            {
              title:'占用汇总',
              align:"center",
              dataIndex: '占用汇总',
              width:100,
            },
            {
              title:'在途数据',
              align:"center",
              dataIndex: '在途数据',
              width:100,
            },
            {
              title:'负库判断',
              align:"center",
              dataIndex: '负库判断',
              width:100,
            }
        ]
      },
      getSuperFieldList(){
        let fieldList=[];
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>